export class ListFindingExclusionPatternsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "paths",
            "baseName": "paths",
            "type": "Array<FindingExclusionPattern>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListFindingExclusionPatternsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
